import React, {Component} from 'react'
import {connect} from 'react-redux'
import {modifyTier} from "../Actions/ModifyTier";
import API_Root from "../Constants/API_Root";
import {ToastContainer, toast} from 'react-toastify'
import { toggleToast } from "../Actions/ToggleToast";
import {modifyCurrency} from "../Actions/ModifyCurrency";
import {initUserHasCurrency} from "../Actions/InitUserHasCurrency";
import {toggleShowingTutorial} from "../Actions/ToggleShowingTutorial";
import {modifyTutorialStep} from "../Actions/ModifyTutorialStep";
import {modifyShowingMinorTutorials} from "../Actions/ModifyShowingMinorTutorials";
import isObjectEmpty from "../Constants/isObjectEmpty";
import {resetAllStates} from "../Actions/ResetAllStates";
import { push } from 'react-router-redux'
import {modifyAppsumoPlanName} from "../Actions/ModifyAppsumoPlanName";
import {modifyConnectedDomains} from "../Actions/ModifyConnectedDomains";
import {initIsGrandfather} from "../Actions/InitIsGrandfather";
import {toggleYearlyPricing} from "../Actions/ToggleYearlyPricing";
import {modifyCurrRequests} from "../Actions/ModifyCurrRequests";
import {modifySubscriptionInfo} from "../Actions/ModifySubscriptionInfo";
import {toggleIsProductImporter} from "../Actions/ToggleIsProductImporter";
import {modifyFullPricingInfo} from "../Actions/ModifyFullPricingInfo";
import API_Backend_Root from "../Constants/API_Backend_Root";
import API_Root_Lambda from "../Constants/API_Root_Lambda";
import {modifyDateJoined} from "../Actions/ModifyDateJoined";
import {modifyDateUpgraded} from "../Actions/ModifyDateUpgraded";
import {cleanDateUpgraded} from "../Constants/cleanDateUpgraded";
import {toggleModal} from "../Actions/ToggleModal";
import {modifyFilePKProBlock} from "../Actions/ModifyFilePKProBlock";
import {modifyTeamInfo} from "../Actions/ModifyTeamInfo";

class CustomToastContainer extends Component {
    stripPaymentParamsFromURL = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('successUpgrade');
        url.searchParams.delete('planId');
        window.history.replaceState({}, '', url.toString());
    };

    componentDidMount(){
        if (localStorage.getItem("email") !== null && localStorage.getItem("token") !== null){
            const current = new Date();
            const utcOffset = current.getTimezoneOffset();

            fetch(API_Backend_Root + "api/get-full-pricing-info/", {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                },
                body: JSON.stringify({
                    email: localStorage.getItem("email"),
                    token: localStorage.getItem("token")
                })
            }).then((res) => {
                if (res.status === 200){
                    res.json().then((data) => {
                        this.props.modifyFullPricingInfo(data.fullPricingInfo)
                    })
                }
            }).catch(err => console.log(err))
            // this.props.modifyFullPricingInfo(data.fullPricingInfo)

            fetch(API_Root_Lambda + "api/get-profile-information/", {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                },
                body: JSON.stringify({
                    utcOffset: utcOffset,
                    email: localStorage.getItem("email"),
                    token: localStorage.getItem("token"),
                    teamHash: localStorage.getItem("activeTeamHash")
                })
            }).then((res) =>
            {
                if (res.status === 200){
                    res.json().then((data) => {
                        const dtJoined = cleanDateUpgraded(data.dateJoined)
                        const dtUpgraded = cleanDateUpgraded(data.datePro)
                        localStorage.setItem("dateJoined", dtJoined);
                        localStorage.setItem("dateUpgraded", dtUpgraded);
                        this.props.modifyDateJoined(dtJoined)
                        this.props.modifyDateUpgraded(dtUpgraded)
                        this.props.toggleIsProductImporter("isProductImporter" in data ? data.isProductImporter : false)
                        this.props.toggleYearlyPricing("yearlyPricing" in data ? data.yearlyPricing : false)
                        this.props.initIsGrandfather(data.isGrandfather)
                        this.props.modifyConnectedDomains(data.connectedDomains)
                        this.props.modifyAppsumoPlanName(data.appsumoPlanName)
                        this.props.modifyTier(data.pricingPlan)
                        this.props.modifyCurrency(data.currency)
                        if (data.teamInfo && Array.isArray(data.teamInfo)) {
                            const slim = data.teamInfo.map(t => ({ id: t.id, name: t.name, team_hash: t.team_hash }));
                            localStorage.setItem('teamInfoSlim', JSON.stringify(slim));
                            this.props.modifyTeamInfo(data.teamInfo)
                        }
                        this.props.initUserHasCurrency(data.userHasCurrency)
                        this.props.modifySubscriptionInfo(data.subscriptionInfo)
                        this.props.modifyCurrRequests(data.currRequests)
                        this.props.toggleShowingTutorial(data.showTutorial)
                        if (!isObjectEmpty(data.minorTutorials)){
                            this.props.modifyShowingMinorTutorials(data.minorTutorials)
                        }
                        if(data.showTutorial){
                            this.props.modifyTutorialStep("userPreference")
                        }
                    }).catch(err => this.props.modifyTier("team"));
                }
                else{
                    this.props.modifyTier("team")
                }

            }).catch(err => this.props.modifyTier("team"))


            // showcase the pricing celebrated modal
            const curr = new URL(window.location.href);
            const isSuccess = curr.searchParams.get('successUpgrade') === 'true';
            const planId = curr.searchParams.get('planId');

            const paymentCompleted = (planIdx) => {
                let updatedFilePKProBlock = {};

                for (let pkID in this.props.filePKProBlock){
                    updatedFilePKProBlock[pkID] = false
                }

                this.props.modifyFilePKProBlock(updatedFilePKProBlock);

                const planNames = ["pro", "team", "business"]
                this.props.modifyTier(planNames[parseInt(planIdx)-1])

                this.stripPaymentParamsFromURL()
                this.props.toggleModal(null)
                this.props.toggleModal("completedCelebrationModal")
            }

            if (isSuccess) {
                paymentCompleted(planId)
            }
        }
        // else {
        //     this.props.navigateTo("/")
        //     auth.doSignOut()
        //     this.props.resetAllStates();
        // }
    }

    render() {
        if (this.props.toast.show){
            const message = this.props.toast.message;
            const toastType = this.props.toast.type;

            if (toastType === "success"){
                toast.success(message)
            }
            else if (toastType === "info"){
                toast.info(message)
            }
            else if (toastType === "warn"){
                toast.warn(message)
            }
            else if (toastType === "error"){
                toast.error(message)
            }

            this.props.toggleToast({show: false, message: "", type: ""})
        }


        return (
            <ToastContainer
                position="top-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover/>
        )
    }
}

const mapStateToProps = (state) => ({
    toast: state.mainState.toast,
    filePKProBlock: state.mainState.filePKProBlock,

})

const mapActionsToProps = {
    modifyTier: modifyTier,
    toggleToast: toggleToast,
    modifyCurrency: modifyCurrency,
    initUserHasCurrency: initUserHasCurrency,
    toggleShowingTutorial: toggleShowingTutorial,
    modifyTutorialStep: modifyTutorialStep,
    modifyShowingMinorTutorials: modifyShowingMinorTutorials,
    resetAllStates: resetAllStates,
    navigateTo: push,
    modifyAppsumoPlanName: modifyAppsumoPlanName,
    modifyConnectedDomains: modifyConnectedDomains,
    initIsGrandfather: initIsGrandfather,
    toggleYearlyPricing: toggleYearlyPricing,
    modifyCurrRequests: modifyCurrRequests,
    modifySubscriptionInfo: modifySubscriptionInfo,
    toggleIsProductImporter: toggleIsProductImporter,
    modifyFullPricingInfo: modifyFullPricingInfo,
    modifyDateJoined: modifyDateJoined,
    modifyDateUpgraded: modifyDateUpgraded,
    toggleModal: toggleModal,
    modifyFilePKProBlock: modifyFilePKProBlock,
    modifyTeamInfo: modifyTeamInfo,
}

export default connect(mapStateToProps, mapActionsToProps)(CustomToastContainer)